<template>
  <div :class="$style.wrapper">
    <WfIcon icon="variables" />
    {{ name }}
  </div>
</template>

<style lang="scss" module>
.wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>

<script setup>
import WfIcon from '@/components/WfIcon.vue';

defineProps({
  name: {
    type: String,
    required: true,
  },
});
</script>
